<template>
  <div>
    <div class="my-container">
      <h2>
        CancerSRT Overview
      </h2>
      <div id="chart1" style="width: auto;height: 700px;margin: 0;padding: 0"></div>
      <div id="chart2" style="width: auto;height: 1000px"></div>
    </div>

    <div class="my-container">
      <h2>Dataset browse</h2>

      <el-table
          fit
          :header-cell-style="{color: 'black'}"
          :data="showData"
          :row-style="{height: '30px'}"
          stripe
          :cell-style="{padding: '0', color: 'black', margin: '0'}">>
        <el-table-column prop="dataset" label="Dataset" align="center" sortable show-overflow-tooltip>
          <template slot-scope="scope">
            <div v-if="scope.$index === 0">
              <el-select v-model="form.Dataset"
                         placeholder="all"
                         clearable
                         filterable
                         multiple
                         @change="getDataset">
                <el-option
                    v-for="item in List.Dataset"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </div>
            <div v-else>{{ (scope.row.dataset) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="sample" label="Sample" align="center" sortable>
          <template slot-scope="scope">
            <div v-if="scope.$index === 0">
              <el-select v-model="form.Sample"
                         placeholder="all"
                         clearable
                         filterable
                         multiple
                         @change="getSample">
                <el-option
                    v-for="item in List.Sample"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </div>
            <div v-else>{{ (scope.row.sample) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="technology" label="Technology" align="center" sortable>
          <template slot-scope="scope">
            <div v-if="scope.$index === 0">
              <el-select v-model="form.Technology"
                         placeholder="all"
                         clearable
                         filterable
                         multiple
                         @change="getTechnology">
                <el-option
                    v-for="item in List.Technology"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </div>
            <div v-else>{{ (scope.row.technology) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="organ" label="Organ" align="center" sortable>
          <template slot-scope="scope">
            <div v-if="scope.$index === 0">
              <el-select v-model="form.Organ"
                         placeholder="all"
                         clearable
                         filterable
                         multiple
                         @change="getOrgan">
                <el-option
                    v-for="item in List.Organ"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </div>
            <div v-else>{{ (scope.row.organ) }}</div>
          </template>
        </el-table-column>
<!--        <el-table-column prop="tissue" label="Tissue" align="center" sortable>-->
<!--          <template slot-scope="scope">-->
<!--            <div v-if="scope.$index === 0">-->
<!--              <el-select v-model="form.Tissue"-->
<!--                         placeholder="all"-->
<!--                         clearable-->
<!--                         filterable-->
<!--                         multiple-->
<!--                         @change="getTissue">-->
<!--                <el-option-->
<!--                    v-for="item in List.Tissue"-->
<!--                    :key="item"-->
<!--                    :label="item"-->
<!--                    :value="item">-->
<!--                </el-option>-->
<!--              </el-select>-->
<!--            </div>-->
<!--            <div v-else>{{ (scope.row.tissue) }}</div>-->
<!--          </template>-->
<!--        </el-table-column>-->
        <el-table-column prop="spots" label="Spots" align="center" sortable>
          <template slot-scope="scope">
            <div v-if="scope.$index === 0">
              <el-select v-model="form.Spots"
                         placeholder="all"
                         clearable
                         filterable
                         multiple
                         @change="getSpots">
                <el-option
                    v-for="item in List.Spots"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </div>
            <div v-else>{{ (scope.row.spots) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="genes" label="Genes" align="center" sortable>
          <template slot-scope="scope">
            <div v-if="scope.$index === 0">
              <el-select v-model="form.Genes"
                         placeholder="all"
                         clearable
                         filterable
                         multiple
                         @change="getGenes">
                <el-option
                    v-for="item in List.Genes"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </div>
            <div v-else>{{ (scope.row.genes) }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="source" label="Source" align="center" sortable>
          <template slot-scope="scope">
            <div v-if="scope.$index === 0">
              <el-select v-model="form.Source"
                         placeholder="all"
                         clearable
                         filterable
                         multiple
                         @change="getSource">
                <el-option
                    v-for="item in List.Source"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </div>
            <div v-else>
              <a :href="scope.row.source" target="_blank">link</a>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination align='center' @size-change="handleSizeChange" @current-change="handleCurrentChange"
                     :current-page="currentPage"
                     :page-sizes="[10,20,50,100]"
                     :page-size="pageSize"
                     layout="total, sizes, prev, pager, next, jumper"
                     :total="tableData.length">
      </el-pagination>
    </div>
  </div>
</template>

<script>

export default {
  name: "Browse",
  data(){
    return{

      //table
      form: {
        Dataset: '',
        Sample: '',
        Technology: '',
        Species: '',
        Organ: '',
        Tissue: '',
        Spots: '',
        Genes: '',
        Source: '',
      },
      List: {
        Dataset: [],
        Sample: [],
        Technology: [],
        Species: [],
        Organ: [],
        Tissue: [],
        Spots: [],
        Genes: [],
        Source: [],
      },
      tableData2:[],
      showData: [],
      tableData: [
        {},
        {
          "dataset": 20210101,
          "sample": "IDC",
          "technology": "ST",
          "organ": "Cancer",
          "tissue": "Cancer",
          "spots": "-",
          "genes": "-",
          "source": "/#/test"
        }
      ],
      currentPage: 1, // 当前页码
      total: 100, // 总条数
      pageSize: 20 // 每页的数据条数
    }
  },
  methods: {
    //初始化echarts
    echartsInit() {
      var data = [
        {
          name: 'Breast\ncancer',
          itemStyle: {
            color: '#FF0000'
          },
          children: [
            {
              name: 'Edward Zhao et al.,\nNat Biotechnol(2021)',
              value: 1,
              itemStyle: {
                color: '#FF6347'
              }
            },
            {
              name: 'Sunny Z Wu et al.,\nNat Genet(2021)',
              value: 1,
              itemStyle: {
                color: '#FF7F50'
              }
              // color: '#f99e1c'
              // color: '#ef5a78'
              // color: '#f7f1bd'
            },
            {
              name: 'PPatrik L Ståhl et al.,\nScience(2016)',
              value: 1,
              itemStyle: {
                color: '#CD5C5C'
              }
              // color: '#f99e1c'
              // color: '#ef5a78'
              // color: '#f7f1bd'
            },
            {
              name: 'Xu C et al.,\nNucleic Acids Research(2022)',
              value: 1,
              itemStyle: {
                color: '#F08080'
              }
            },
            {
              name: 'WTA,10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#E9967A'
              }
            },
            {
              name: 'Fu H et al.,\nbioRxiv(2021)',
              value: 1,
              itemStyle: {
                color: '#f99e1c'
              }
            },
            {
              name: 'BlockA_Section2,\n10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#ef5a78'
              }
            },
            {
              name: 'Andersson A et al.,\nbioRxiv(2020)',
              value: 1,
              itemStyle: {
                color: '#f7f1bd'
              }
            },
            {
              name: 'Liu YM A et al.,\nAdv Sci(2023)',
              value: 1,
              itemStyle: {
                color: '#f3f294'
              }
            },
          ]
        },
        {
          name: 'PDAC',
          itemStyle: {
            color: '#FFFF00'
          },
          children: [
            {
              name: 'Moncada et al.,\nNat Biotechnol(2020)',
              value: 1,
              itemStyle: {
                color: '#9ACD32'
              }
            },
            {
              name: 'Suhail Yousuf et al.,\nGastroenterology(2023)',
              value: 1,
              itemStyle: {
                color: '#9AFF9A'
              }
            },
            {
              name: 'Meilin Xue et al.,\nNat Commun.(2023)',
              value: 1,
              itemStyle: {
                color: '#556B2F'
              }
            }
          ]
        },
        {
          name: 'squamous cell\ncarcinoma',
          itemStyle: {
            color: '#008000'
          },
          children: [
            {
              name: 'Andrew L. Ji et al.,\nCell(2020)',
              value: 1,
              itemStyle: {
                color: '#228B22'
              }
            }
          ]
        },
        {
          name: 'Melanoma',
          itemStyle: {
            color: '#00FFFF'
          },
          children: [
            {
              name: 'Kim Thrane et al.,\nCancer Res(2018)',
              value: 1,
              itemStyle: {
                color: '#E0FFFF'
              }
            },
            {
              name: 'Biermann J et al.,\nCell.(2022)',
              value: 1,
              itemStyle: {
                color: '#CCFFFF'
              }
            }
          ]
        },
        {
          name: 'Prostate\nCancer',
          itemStyle: {
            color: '#ADD8E6'
          },
          children: [
            {
              name: 'Emelie Berglund et al.,\nNat Commun(2018)',
              value: 1,
              itemStyle: {
                color: '#00BFFF'
              }
            },
            {
              name: 'ACC,10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#6495ED'
              }
            },
            {
              name: 'AIC,10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#1E90FF'
              },
            },
            {
              name: 'ANS,10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#5533FF'
              }
            },
            {
              name: 'Xue, M. et al.,Nat Commun(2023)',
              value: 1,
              itemStyle: {
                color: '#6495ED'
              }
            }
          ]
        },
        {
          name: 'Liver\ncancer',
          itemStyle: {
            color: '#0000FF'
          },
          children: [
            {
              name: 'Hassan Massalha et al.,\nMol Syst Biol(2020) ',
              value: 1,
              itemStyle: {
                color: '#55DDFF'
              }
            },
            {
              name: 'RUI WU et al.,\nSCIENCE(2021)',
              value: 1,
              itemStyle: {
                color: '#4169E1'
              }
            },
            {
              name: 'Zuo Q et al.,\nMol Cancer Res(2022)',
              value: 1,
              itemStyle: {
                color: '#3366FF'
              }
            }
          ]
        },
        {
          name: 'Ovarian\nCancer',
          itemStyle: {
            color: '#800080'
          },
          children: [
            {
              name: 'TIP,10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#FFBFD8'
              }
            },
            {
              name: 'TPCP,10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#FFE4C4'
              }
            },
            {
              name: 'WTA,10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#DDA0DD'
              }
            },
            {
              name: 'OC,10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#EE82EE'
              }
            },
            {
              name: 'Pavel I et al.,BMC Genomics.(2023)',
              value: 1,
              itemStyle: {
                color: '#EEAAEE'
              }
            },
            {
              name: 'MERFISH.,MERSCOPE.(2022)',
              value: 1,
              itemStyle: {
                color: '#EEAAFF'
              }
            }
          ]
        },
        {
          name: 'Glioblastoma',
          itemStyle: {
            color: '#FFC0CB'
          },
          children: [
            {
              name: 'TPCP,10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#FFB6C1'
              }
            },
            {
              name: 'WTA,10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#FF69B4'
              }
            },
            {
              name: 'Yanming Ren al.,\n Nat Commun(2023)',
              value: 1,
              itemStyle: {
                color: '#FFBFD8'
              }
            },
            {
              name: 'Vidhya M Ravi et al.,\nCancer Cell(2022)',
              value: 1,
              itemStyle: {
                color: '#FF69B4'
              }
            }

          ]
        },
        {
          name: 'Colorectal\nCancer',
          itemStyle: {
            color: '#F5DEB3'
          },
          children: [
            {
              name: 'Yingcheng Wu et al.,\nCancer Discov(2022)',
              value: 1,
              itemStyle: {
                color: '#FFEBCD'
              }
            },
            {
              name: 'TGSP,10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#FFE4C4'
              }
            },
            {
              name: 'WTA,10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#F5F5DC'
              }
            },
            {
              name: 'IC,\n10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#4B4B00'
              }
            },
            {
              name: 'Ombretta Garbarinoet al.,\n Aging Cell(2023)',
              value: 1,
              itemStyle: {
                color: '#4BFF00'
              }
            },
            {
              name: 'Fei Wang al.,\n Sci Adv(2023)',
              value: 1,
              itemStyle: {
                color: '#4BAA4B'
              }
            }

          ]
        },
        {
          name: 'Cervical\ncancer',
          itemStyle: {
            color: '#708090'
          },
          children: [
            {
              name: 'CC,\n10xgenomics(2020)',
              value: 1,
              itemStyle: {
                color: '#B0C4DE'
              }
            }
          ]
        },
        // {
        //   name: 'Intestine\ncancer',
        //   itemStyle: {
        //     color: '#4B4B4B'
        //   },
        //   children: [
        //     {
        //       name: 'IC,\n10xgenomics(2020)',
        //       value: 1,
        //       itemStyle: {
        //         color: '#4B4B00'
        //       }
        //     }
        //   ]
        // },
        {
          name: 'Bladder\ncancer',
          itemStyle: {
            color: '#24C424'
          },
          children: [
            {
              name: 'Kenneth H. Gouin III et al.\nNature Communications(2021)',
              value: 1,
              itemStyle: {
                color: '#24C4C0'
              }
            }
          ]
        },
        {
          name: 'Brain\nmetastases',
          itemStyle: {
            color: '#6666CC'
          },
          children: [
            {
              name: 'Kenneth H. Gouin III et al.\nNature Communications(2021)',
              value: 1,
              itemStyle: {
                color: '#993399'
              }
            }
          ]
        },
        {
          name: 'Lung\ncancer',
          itemStyle: {
            color: '#6699CC'
          },
          children: [
            {
              name: 'Li Zhang et al.,\nbioRxiv(2021)',
              value: 1,
              itemStyle: {
                color: '#003366'
              }
            }
          ]
        },
        {
          name: 'Head and neck\ncancer',
          itemStyle: {
            color: '#FF00CC'
          },
          children: [
            {
              name: 'Jui Wan Loh et al.,\nCommun Biol(2023)',
              value: 1,
              itemStyle: {
                color: '#FF7F50'
              }
            },
            {
              name: 'Rohit Arora et al.,\nNat Commun (2023)',
              value: 1,
              itemStyle: {
                color: '#FF69B4'
                // Andrew Causer  NPJ Precis Oncol (2023)
              }
            },
            {
              name: 'Andrew Causer et al.,\nNPJ Precis Oncol (2023)',
              value: 1,
              itemStyle: {
                color: '#FFBFD8'
                // Andrew Causer  NPJ Precis Oncol (2023)
              }
            },
            {
              name: 'Gong L et al.,\nNat Commun.(2023)',
              value: 1,
              itemStyle: {
                color: '#FFBBAA'
                // Andrew Causer  NPJ Precis Oncol (2023)
              }
            },
          ]
        }
      ];
      var option = {
        // title: {
        //   text: 'Dataset Introduction',
        //   subtext: 'author,journal(year)',
        //   textStyle: {
        //     fontSize: 14,
        //     align: 'center'
        //   },
        //   subtextStyle: {
        //     align: 'center'
        //   }
        // },
        series: {
          type: 'sunburst',
          data: data,
          radius: [0, '95%'],
          // radius: '100%',
          // center: ['50%', '50%'],
          sort: undefined,
          emphasis: {
            focus: 'ancestor'
          },
          levels: [
            {},
            {
              r0: '10%',
              r: '40%',
              itemStyle: {
                borderWidth: 2
              },
              label: {
                //控制是否癌症标签名旋转
                // rotate: 'tangential'
              }
            },
            {
              r0: '40%',
              r: '90%',
              label: {
                align: 'right'
              }
            },
            {
              r0: '90%',
              r: '92%',
              label: {
                position: 'outside',
                padding: 3,
                silent: false
              },
              itemStyle: {
                borderWidth: 3
              }
            }
          ]
        }
      };

      this.$echarts.init(document.getElementById('chart1')).setOption(option);

    },
    echartsInit2() {
      const builderJson = {
        all_samples: 665947,
        // all_genes: 2458066,
        charts: {
          'Breast cancer': 69524,
          'Pancreatic ductal adenocarcinoma': 50490,
          'Skin squamous cell carcinoma': 17319,
          'Melanoma': 462551,
          'Prostate cancer': 16783,
          'Liver cancer': 103439,
          // 'Liver cancer': 63,84571
          'Ovarian Cancer': 99264,
          'Glioblastoma': 116884,
          // 'Colorectal Cancer': 37572,
          'Colorectal Cancer': 72551,
          'Cervical Cancer': 2781,
          // 'Intestine Cancer': 2260,
          'Bladder Cancer': 4086,
          'Brain metastases': 12566,
          'Lung Cancer': 3858,
          'Head and neck Cancer': 37281
        },
        // components: {
        //   'Breast cancer': 885191,
        //   'Pancreatic ductal adenocarcinoma': 183381,
        //   'Skin squamous cell carcinoma': 339553,
        //   'Melanoma': 77523,
        //   'Prostate cancer': 162609,
        //   'Liver cancer': 15886,
        //   'Ovarian Cancer': 53853,
        //   'Glioblastoma': 34854,
        //   'Colorectal Cancer': 315551,
        //   'Cervical Cancer': 17943,
        //   'Intestine Cancer': 17943,
        //   'Bladder Cancer': 134152,
        //   'Brain metastases': 219606,
        //   'Lung Cancer': 0
        // },
        // ie: 9743
      };
      const downloadJson = {
        'Breast cancer': 9,
        'Pancreatic ductal\nadenocarcinoma': 3,
        'Skin squamous\ncell carcinoma': 1,
        'Melanoma': 2,
        'Prostate cancer': 4,
        'Liver cancer': 3,
        'Ovarian Cancer': 6,
        'Glioblastoma': 4,
        // 'Colorectal Cancer': 3,
        'Colorectal Cancer': 6,
        'Cervical Cancer': 1,
        // 'Intestine Cancer': 1,
        'Bladder Cancer': 1,
        'Brain metastases': 1,
        'Lung Cancer': 1,
        'Head and neck Cancer': 4
      };
      const themeJson = {
        'Breast cancer': 55,
        'Pancreatic ductal\nadenocarcinoma': 22,
        'Skin squamous\ncell carcinoma': 16,
        'Melanoma': 24,
        'Prostate cancer': 15,
        'Liver cancer': 108,
        'Ovarian Cancer': 11,
        'Glioblastoma': 43,
        // 'Colorectal Cancer': 10,
        'Colorectal Cancer': 21,
        'Cervical Cancer': 1,
        // 'Intestine Cancer': 1,
        'Bladder Cancer': 4,
        'Brain metastases': 6,
        'Lung Cancer': 1,
        'Head and neck Cancer': 20
      };
      // const waterMarkText = 'CancerSRT';
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = canvas.height = 100;
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.globalAlpha = 0.08;
      ctx.font = '20px Microsoft Yahei';
      ctx.translate(50, 50);
      ctx.rotate(-Math.PI / 4);
      // ctx.fillText(waterMarkText, 0, 0);
      var option = {
        backgroundColor: {
          type: 'pattern',
          image: canvas,
          repeat: 'repeat'
        },
        tooltip: {},
        title: [
          {
            text: 'Number of spots in each cancer type',
            subtext: 'total ' +
                Object.keys(builderJson.charts).reduce(function (all, key) {
                  return all + builderJson.charts[key];
                }, 0),
            left: '50%',
            textAlign: 'center'
          },
          {
            text: 'Proportion of datasets for each cancer',
            subtext:
                'total ' +
                Object.keys(downloadJson).reduce(function (all, key) {
                  return all + downloadJson[key];
                }, 0),
            top: '55%',
            left: '25%',
            textAlign: 'center'
          },
          {
            text: 'Proportion of sub-datasets for each cancer',
            subtext:
                'total ' +
                Object.keys(themeJson).reduce(function (all, key) {
                  return all + themeJson[key];
                }, 0),
            left: '75%',
            top: '55%',
            textAlign: 'center'
          }
        ],
        grid: [
          {
            top: 50,
            width: '80%',
            bottom: '50%',
            left: '10%',
            containLabel: true
          },
          {
            top: '55%',
            width: '50%',
            bottom: 0,
            left: 0,
            containLabel: true
          },
          {
            top: '55%',
            width: '50%',
            bottom: 0,
            right: 0,
            containLabel: true
          }
          // {
          //   top: 50,
          //   width: '50%',
          //   bottom: '45%',
          //   left: 10,
          //   containLabel: true
          // },
          // {
          //   top: '55%',
          //   width: '50%',
          //   bottom: 0,
          //   left: 10,
          //   containLabel: true
          // }
        ],
        xAxis: [
          {
            type: 'value',
            gridIndex: 0,
            // max: builderJson.all_samples,
            splitLine: {
              show: false
            }
          },
          {
            type: 'value',
            // max: builderJson.all_genes,
            gridIndex: 1,
            splitLine: {
              show: false,
            }
          }
        ],
        yAxis: [
          {
            gridIndex: 0,
            type: 'category',
            data: Object.keys(builderJson.charts),
            axisLabel: {
              interval: 0,
              rotate: 30
            },
            splitLine: {
              show: false
            }
          },
          {
            gridIndex: 1,
            // data: Object.keys(builderJson.components),
            axisLabel: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            splitLine: {
              show: false
            }
          }
        ],
        series: [
          {
            type: 'bar',
            stack: 'chart',
            z: 3,
            label: {
              position: 'right',
              show: true
            },
            data: Object.keys(builderJson.charts).map(function (key) {
              return builderJson.charts[key];
            })
          },
          {
            type: 'bar',
            stack: 'chart',
            silent: true,
            itemStyle: {
              color: '#eee'
            },
            data: Object.keys(builderJson.charts).map(function (key) {
              return builderJson.all - builderJson.charts[key];
            })
          },
          // {
          //   type: 'bar',
          //   stack: 'component',
          //   xAxisIndex: 1,
          //   yAxisIndex: 1,
          //   z: 3,
          //   label: {
          //     position: 'right',
          //     show: true
          //   },
          //   data: Object.keys(builderJson.components).map(function (key) {
          //     return builderJson.components[key];
          //   })
          // },
          // {
          //   type: 'bar',
          //   stack: 'component',
          //   silent: true,
          //   xAxisIndex: 1,
          //   yAxisIndex: 1,
          //   itemStyle: {
          //     color: '#eee'
          //   },
          //   data: Object.keys(builderJson.components).map(function (key) {
          //     return builderJson.all - builderJson.components[key];
          //   })
          // },
          {
            type: 'pie',
            radius: [0, '30%'],
            center: ['25%', '80%'],
            data: Object.keys(downloadJson).map(function (key) {
              return {
                name: key.replace('.js', ''),
                value: downloadJson[key]
              };
            })
          },
          {
            type: 'pie',
            radius: [0, '30%'],
            center: ['75%', '80%'],
            data: Object.keys(themeJson).map(function (key) {
              return {
                name: key.replace('.js', ''),
                value: themeJson[key]
              };
            })
          }
        ]
      };


      this.$echarts.init(document.getElementById('chart2')).setOption(option);

    },

    getDatasets() {
      let _this = this
      console.log(_this.tableData)
      _this.$axios.get(
          'http://'+ _this.$global.serverIP+':'+_this.$global.serverHost +'/browse/datasets')
          .then(function (response){
            console.log('datasets:')
            console.log(response)
            _this.List = response.data.List
            _this.tableData = response.data.tableData
            _this.tableData2 = Array.from(_this.tableData)
            _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
            _this.showData.unshift('{}')
          })
    },
    getDataset(){
      let _this = this
      if (_this.form.Dataset.length === 0){
        _this.tableData = Array.from(_this.tableData2)
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
      }else {
        let tempArray = []
        for (let item in _this.tableData2){
          if (_this.form.Dataset.includes(_this.tableData2[item].dataset)){
            tempArray.push(_this.tableData2[item])
          }
        }
        _this.tableData = tempArray
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
        console.log(tempArray)
      }
    },
    getSample(){
      let _this = this
      if (_this.form.Sample.length === 0){
        _this.tableData = Array.from(_this.tableData2)
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
      }else {
        let tempArray = []
        for (let item in _this.tableData2){
          if (_this.form.Sample.includes(_this.tableData2[item].sample)){
            tempArray.push(_this.tableData2[item])
          }
        }
        _this.tableData = tempArray
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
        console.log(tempArray)
      }
    },
    getTechnology(){
      let _this = this
      if (_this.form.Technology.length === 0){
        _this.tableData = Array.from(_this.tableData2)
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
      }else {
        let tempArray = []
        for (let item in _this.tableData2){
          if (_this.form.Technology.includes(_this.tableData2[item].technology)){
            tempArray.push(_this.tableData2[item])
          }
        }
        _this.tableData = tempArray
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
        console.log(tempArray)
      }
    },
    getOrgan(){
      let _this = this
      if (_this.form.Organ.length === 0){
        _this.tableData = Array.from(_this.tableData2)
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
      }else {
        let tempArray = []
        for (let item in _this.tableData2){
          if (_this.form.Organ.includes(_this.tableData2[item].organ)){
            tempArray.push(_this.tableData2[item])
          }
        }
        _this.tableData = tempArray
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
        console.log(tempArray)
      }
    },
    getTissue(){
      let _this = this
      if (_this.form.Tissue.length === 0){
        _this.tableData = Array.from(_this.tableData2)
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
      }else {
        let tempArray = []
        for (let item in _this.tableData2){
          if (_this.form.Tissue.includes(_this.tableData2[item].tissue)){
            tempArray.push(_this.tableData2[item])
          }
        }
        _this.tableData = tempArray
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
        console.log(tempArray)
      }
    },
    getSpots(){
      let _this = this
      if (_this.form.Spots.length === 0){
        _this.tableData = Array.from(_this.tableData2)
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
      }else {
        let tempArray = []
        for (let item in _this.tableData2){
          if (_this.form.Spots.includes(_this.tableData2[item].spots)){
            tempArray.push(_this.tableData2[item])
          }
        }
        _this.tableData = tempArray
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
        console.log(tempArray)
      }
    },
    getGenes(){
      let _this = this
      if (_this.form.Genes.length === 0){
        _this.tableData = Array.from(_this.tableData2)
        _this.tableData.unshift('{}')
      }else {
        let tempArray = []
        for (let item in _this.tableData2){
          if (_this.form.Genes.includes(_this.tableData2[item].genes)){
            tempArray.push(_this.tableData2[item])
          }
        }
        _this.tableData = tempArray
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
        console.log(tempArray)
      }
    },
    getSource(){
      let _this = this
      if (_this.form.Source.length === 0){
        _this.tableData = Array.from(_this.tableData2)
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
      }else {
        let tempArray = []
        for (let item in _this.tableData2){
          if (_this.form.Source.includes(_this.tableData2[item].source)){
            tempArray.push(_this.tableData2[item])
          }
        }
        _this.tableData = tempArray
        _this.showData = _this.tableData.slice((_this.currentPage-1)*_this.pageSize,_this.currentPage*_this.pageSize)
        _this.showData.unshift('{}')
        console.log(tempArray)
      }
    },
    //每页条数改变时触发 选择一页显示多少行
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.pageSize = val;
      this.showData = this.tableData.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize)
      this.showData.unshift('{}')
    },
    //当前页改变时触发 跳转其他页
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.showData = this.tableData.slice((this.currentPage-1)*this.pageSize,this.currentPage*this.pageSize)
      this.showData.unshift('{}')
      console.log(this.showData)
    },
  },
  mounted() {
    // 在通过mounted调用即可
    this.echartsInit()
    this.echartsInit2()
  },
  created() {
    this.getDatasets()
  }
}
</script>

<style scoped>

</style>
